module.exports = __webpack_public_path__ + "static/Slide02-6ef0707298ead52b9c4c0fb106186745.png";